import store from "../index.js";
import api from "../../utils/api";
import router from "@/router/index.js";
import PortOne from "@portone/browser-sdk/v2";

export const modules = {
  store,
};

export const state = {};

export const mutations = {};

export const actions = {
  /**
   * 포트원 결제창 띄우기 위한 정보 획득.
   */
  async acPortoneInfo(context, { pg_name, init_type = null }) {
    try {
      const res = await api.get(`/api/v1/portone/info?pg_name=${pg_name}&init_type=${init_type}`);
      return res.data.data;
    } catch (error) {
      window.console.error("[acPortoneInfo] 포트원 정보 조회 실패:", {
        pg_name,
        init_type,
        error: error?.response?.data || error.message,
      });
      return null;
    }
  },

  /**
   * 포트원에서 발급 받은 빌링키 서버에 전송.
   */
  async acPortoneBillingKey(
    context,
    { billing_key, merchant_uid, order_name, pg_name, converted, premium_subscribe_seq },
  ) {
    // window.console.log("acPortoneBillingKey", params);
    try {
      const body = {
        billing_key,
        pg_name,
        merchant_uid,
        order_name,
      };

      // 프리미엄 전환 정보 추가
      if (converted && premium_subscribe_seq) {
        body.converted = converted;
        body.premium_subscribe_seq = premium_subscribe_seq;
      }

      const res = await api.post(`/api/v1/portone/payment/billingkey`, body);
      return res.status === 200;
    } catch (error) {
      window.console.error("[acPortoneBillingKey] 빌링키 전송 실패:", {
        merchant_uid,
        pg_name,
        error: error?.response?.data || error.message,
      });
      return false;
    }
  },

  /**
   * 포트원에서 발급 받은 빌링키 카드변경 용도로 서버에 전송.
   */
  async acPortoneBillingKeyUpdate(context, { billing_key, uids, pg_name }) {
    try {
      const res = await api.patch(`/api/v1/portone/card-change`, {
        billing_key,
        uids,
        pg_name,
      });
      if (res.data?.code === 0) {
        return true;
      } else {
        window.console.error("[acPortoneBillingKeyUpdate] 카드 변경 실패:", {
          uids,
          pg_name,
          response: res.data,
        });
        return false;
      }
    } catch (error) {
      window.console.error("[acPortoneBillingKeyUpdate] 카드 변경 API 오류:", {
        uids,
        pg_name,
        error: error?.response?.data || error.message,
      });
      return false;
    }
  },

  /**
   * 포트원에서 빌링키 발급 및 서버에 전송.
   */
  async acPortonePayment(
    { dispatch },
    {
      pg_name,
      is_yearly,
      merchant_uid,
      store_id,
      channel_key,
      user_no,
      converted,
      premium_subscribe_seq,
    },
  ) {
    const order_name = is_yearly ? "우리집알리미시작_연간" : "우리집알리미시작";
    // window.console.log("redirectUrl", `${process.env.VUE_APP_HOST}/api/v1/portone/payment/complete/${user_no}/${merchant_uid}/${order_name}/${pg_name}`);

    // 프리미엄 전환 정보 쿼리 파라미터 생성
    const convertedParam =
      converted && premium_subscribe_seq
        ? `?converted=true&premium_subscribe_seq=${premium_subscribe_seq}`
        : "";

    // 빌링키 발급
    const billingKeyRes = await PortOne.requestIssueBillingKey({
      storeId: store_id,
      channelKey: channel_key,
      billingKeyMethod: "EASY_PAY",
      issueName: "우리집알리미 정기결제", // 빌링키 발급 시 결제창에 표시되는 제목
      redirectUrl:
        `${process.env.VUE_APP_HOST}` +
        `/api/v1/portone/payment/complete` +
        `/${user_no}/${merchant_uid}` +
        `/${encodeURIComponent(order_name)}` +
        `/${pg_name}` +
        convertedParam,
    });
    if (billingKeyRes.message === "사용자가 프로세스를 중단하였습니다.") {
      alert("결제를 종료하였습니다.");
    } else {
      const paymentSuccess = await dispatch("acPortoneBillingKey", {
        billing_key: billingKeyRes.billingKey,
        merchant_uid: merchant_uid,
        order_name: is_yearly ? "우리집알리미시작_연간" : "우리집알리미시작",
        pg_name: pg_name,
        converted: converted,
        premium_subscribe_seq: premium_subscribe_seq,
      });
      // window.console.log("PortOne paymentSuccess", paymentSuccess);
      if (paymentSuccess) {
        if (merchant_uid?.startsWith("sbulk")) {
          router.push("/subscribe/owner-house-complete");
        } else {
          router.push("/subscribe/complete");
        }
      } else {
        router.push("/analyze/error");
      }
    }
  },

  async acPortoneCardChange(
    { dispatch },
    {
      pg_name,
      store_id,
      channel_key,
      user_no,
      card_change_subscribe_seqs, // number[]
    },
  ) {
    // 빌링키 발급
    const billingKeyRes = await PortOne.requestIssueBillingKey({
      storeId: store_id,
      channelKey: channel_key,
      billingKeyMethod: "EASY_PAY",
      issueName: "우리집알리미 정기결제", // 빌링키 발급 시 결제창에 표시되는 제목
      redirectUrl:
        `${process.env.VUE_APP_HOST}` +
        `/api/v1/portone/card-change/complete` +
        `/${user_no}` +
        `/${pg_name}` +
        `/${card_change_subscribe_seqs.join(",")}`,
    });
    if (billingKeyRes.message === "사용자가 프로세스를 중단하였습니다.") {
      alert("결제를 종료하였습니다.");
    } else {
      const cardChangeSuccess = await dispatch("acPortoneBillingKeyUpdate", {
        pg_name: pg_name,
        billing_key: billingKeyRes.billingKey,
        uids: card_change_subscribe_seqs,
      });
      // window.console.log("PortOne cardChangeSuccess", cardChangeSuccess);
      if (cardChangeSuccess) {
        // alert("수정이 완료되었습니다.");
        // router.push("/");

        router.push(
          `/subscribe/card-change-complete?rst=success&code=200&msg=${billingKeyRes.message}&player=${billingKeyRes.billingKey}&uids=${card_change_subscribe_seqs}&pg_name=${pg_name}`,
        );
      } else {
        alert("등록 실패");
        // router.push("/analyze/error");
        return false;
      }
    }
  },

  /** 셜록 카카오페이 카드 등록. */
  async acPortoneSherlockCardRegister(
    { dispatch },
    {
      pg_name,
      store_id,
      channel_key,
      user_no,
      card_change_subscribe_seqs, // number[]
      completePathClient,
      completePathServer,
    },
  ) {
    // 빌링키 발급
    const billingKeyRes = await PortOne.requestIssueBillingKey({
      storeId: store_id,
      channelKey: channel_key,
      billingKeyMethod: "EASY_PAY",
      issueName: "자산원클릭 카드 등록", // 빌링키 발급 시 결제창에 표시되는 제목
      redirectUrl: completePathServer,
    });
    return billingKeyRes;
  },

  /**
   * 포트원에서 빌링키 발급 및 서버에 전송. -페이 결제용
   */
  async acPortonePaymentPay(
    { commit },
    { pg_name, merchant_uid, store_id, channel_key, user_no, issue_name, pay_order_type },
  ) {
    try {
      // 빌링키 발급
      const billingKeyRes = await PortOne.requestIssueBillingKey({
        storeId: store_id,
        channelKey: channel_key,
        billingKeyMethod: "EASY_PAY",
        issueName: issue_name,
        redirectUrl:
          `${process.env.VUE_APP_HOST}` +
          `/api/v1/pay-order-redirect/complete/kakaopay` +
          `/${user_no}/${merchant_uid}` +
          `/${encodeURIComponent(pay_order_type)}` +
          `/${pg_name}`,
      });

      return billingKeyRes;
    } catch (error) {
      window.console.error("[acPortonePaymentPay] 빌링키 발급 실패:", {
        pg_name,
        merchant_uid,
        error: error?.message || error,
      });
      return null;
    }
  },

  async acPortoneKakaopayOneTimePayment(
    { commit },
    {
      merchant_uid,
      store_id,
      channel_key,
      user_no,
      order_name,
      price,
      user_name,
      email,
      mobile,
      document,
      seq,
      redirect,
    },
  ) {
    try {
      let redirectUrl =
        `${process.env.VUE_APP_HOST}` +
        `/api/v1/portone/payment-onetime/complete` +
        `/${user_no}/${merchant_uid}` +
        `/${encodeURIComponent(order_name)}` +
        `/kakaopay` +
        `/${encodeURIComponent(document)}` +
        `/${encodeURIComponent(seq)}`;

      // redirect 파라미터가 있으면 추가
      if (redirect) {
        redirectUrl += `?redirect=${encodeURIComponent(redirect)}`;
      }

      const billingKeyRes = await PortOne.requestPayment({
        paymentId: merchant_uid,
        storeId: store_id,
        channelKey: channel_key,
        orderName: order_name,
        payMethod: "EASY_PAY",
        totalAmount: price,
        customer: {
          id: user_no,
          name: {
            full: user_name,
          },
          email: email,
          phoneNumber: mobile,
        },
        currency: "KRW",
        redirectUrl: redirectUrl,
      });

      return billingKeyRes;
    } catch (error) {
      window.console.error("[acPortoneKakaopayOneTimePayment] 일회성 결제 실패:", {
        merchant_uid,
        order_name,
        price,
        error: error?.message || error,
      });
      return null;
    }
  },

  /**************************************************************
   * 셜록 포인트 충전 - 카카오페이 빌링키 발급
   * 빌링키 발급 후 서버에서 결제 처리
   **************************************************************/
  async acPortoneSherlockPayment(
    { dispatch },
    { pg_name, merchant_uid, store_id, channel_key, user_no, product_code },
  ) {
    try {
      // 빌링키 발급
      const billingKeyRes = await PortOne.requestIssueBillingKey({
        storeId: store_id,
        channelKey: channel_key,
        billingKeyMethod: "EASY_PAY",
        issueName: "셜록 포인트 충전",
        redirectUrl:
          `${process.env.VUE_APP_HOST}` +
          `/api/v1/sherlock/payment/portone/complete` +
          `/${user_no}/${merchant_uid}` +
          `/${product_code}` +
          `/${pg_name}`,
      });

      return billingKeyRes;
    } catch (error) {
      window.console.error("[acPortoneSherlockPayment] 셜록 빌링키 발급 실패:", {
        pg_name,
        merchant_uid,
        product_code,
        error: error?.message || error,
      });
      return null;
    }
  },

  /**************************************************************
   * 셜록 포인트 충전 - 카카오페이 빌링키로 결제 요청
   * 발급받은 빌링키를 서버에 전송하여 결제 처리
   **************************************************************/
  async acPortoneSherlockBillingKey(context, { billing_key, merchant_uid, pg_name }) {
    try {
      const res = await api.post(`/api/v1/sherlock/payment/portone/billing-key`, {
        billing_key,
        merchant_uid,
        pg_name,
      });
      return res.data;
    } catch (error) {
      window.console.error("[acPortoneSherlockBillingKey] 셜록 빌링키 결제 실패:", {
        merchant_uid,
        pg_name,
        error: error?.response?.data || error.message,
      });
      return {
        success: false,
        message: error?.response?.data?.message || "결제 처리 중 오류가 발생했습니다.",
      };
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
